import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { taskPriorityFilterConfig } from '../../../configs/task-priority-filter-config';

export const TaskPriorityFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Priority'
      config={taskPriorityFilterConfig}
    />
  );
};
